var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFifa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 46,
    viewBox: "0 0 131 46",
    fill: "#93C11A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70018 0.0664062H42.779L41.0417 10.115H19.592L18.122 18.5558H35.4064L33.6913 28.6044H16.2287L13.3108 45.9996H0.637085L8.70018 0.0664062Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2115 0.0664062H59.8184L51.733 45.9996H39.1261L47.2115 0.0664062Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.251 0.0664062H98.3076L96.5925 10.115H75.1429L73.6728 18.5558H90.9572L89.2421 28.6044H71.9132L68.9062 45.9996H56.3215L64.251 0.0664062Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.865 0H123.143L130.493 46.0002H117.842L116.817 37.939H101.003L97.1493 46.0002H84.9878L108.865 0ZM115.547 28.3594L113.32 11.7903H113.075L105.546 28.4487L115.547 28.3594Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifa);
export default __webpack_public_path__ + "static/media/FIFA.6dd9eb44a2baeb6eb60b976c8a498616.svg";
export { ForwardRef as ReactComponent };